import { render, staticRenderFns } from "./pre_excel_up_new.vue?vue&type=template&id=518560c1&scoped=true"
import script from "./pre_excel_up_new.vue?vue&type=script&lang=js"
export * from "./pre_excel_up_new.vue?vue&type=script&lang=js"
import style0 from "./pre_excel_up_new.vue?vue&type=style&index=0&id=518560c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518560c1",
  null
  
)

export default component.exports